<p class="paragraph paragraph--font-size-{{ fontSize }}" [ngStyle]="{ 'max-width.px': maxWidth }">
  <ng-content></ng-content>
</p>
